export const V2_STIMULUS_PROGRESSION = {
  MANUAL: 'MANUAL',
};

export const V2_STIMULUS_RENDERER = {
  MAIN_UI: 'MAIN_UI',
};